import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import cssStyles from './SidebarLeft.module.css';

// Icons import
import DoriLogo from 'Assets/Logo/dori_logo_196x196.png';
import DoriLogoFull from 'Assets/Icons/dori_logo_full.png';
import HamburgerMenu from 'Assets/Icons/HamburgerMenu.svg';
import CrossIcon from 'Assets/Icons/CrossIcon.svg';
import LogoutIcon from '@mui/icons-material/Logout';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import store from 'storage';

//MUI components import
import Drawer from '@mui/material/Drawer';
import { dashRoutesUserManuAdmin } from "routes";
import { handleDateFormat } from "HelperFiles/DateHelper";

const SidebarLeft = () => {
  const navigate = useNavigate();
  const [showLeftDrawer, setShowLeftDrawer] = useState(false);
  const [selectedLeftOption, setSelectedLeftOption] = useState('');

  // useEffect(() => {
  //   const pathname = window.location.pathname;
  //   const tempLeftOption = LeftDrawerOptions.find((f) => f.path === pathname);
  //   if (tempLeftOption) {
  //     setSelectedLeftOption(tempLeftOption.name);
  //   } else {
  //     setSelectedLeftOption('Projects');
  //   }
  //   if (window.location.pathname !== '/projects') {
  //     navigate('/projects');
  //   }
  // }, []);

  const isSelected = (path) => {
    return window.location.href.includes(path)
  }

  return (
    <div
      className={cssStyles.SidebarLeftContainer}
      onMouseEnter={() => {
        console.log('mouse in');
        setShowLeftDrawer(true);
      }}
    >
      <div
        className={cssStyles.LogoIcon}
        style={{ height: '90px' }}
      >
        <img
          src={DoriLogo}
          alt='dorilogo'
          className={cssStyles.LeftSidebarIcons}
          height='50%'
        />
      </div>
      {/* <div className={cssStyles.leftSidebarIconsWrapper} onClick={() => setShowLeftDrawer(true)}>
        <img src={HamburgerMenu} alt='hamburger' className={cssStyles.LeftSidebarIcons} />
      </div> */}

      {
        dashRoutesUserManuAdmin.map((option, index) => {
          return (
            <div
              key={index}
              // className={selectedLeftOption === option.name
              //   ? `${cssStyles.leftSidebarIconsWrapper} ${cssStyles.leftSidebarIconsWrapperSelected}`
              //   : cssStyles.leftSidebarIconsWrapper}
              onClick={() => {
                setSelectedLeftOption(option.name);
                navigate(option.layout + option.path);
              }}
              style={{
                display: 'flex',
                justifyContent: 'center',
                margin: '10px 0'
              }}
            >
              <div
                style={{
                  backgroundColor:
                    isSelected(option.layout + option.path)
                      ? 'white' : '',
                }}
                className={cssStyles.sidebarIconContainer}
              >
                {
                  isSelected(option.layout + option.path)
                    ? option.icon('#17b696')
                    : option.icon('rgb(214, 214, 214)')
                }
              </div>
            </div>
          );
        })
      }

      <div className={cssStyles.profilePicContainer}>
        <div className={cssStyles.profilePicWrapper}>
          <AccountCircleIcon style={{ width: '80%', height: '80%', color: 'white' }} />
        </div>
      </div>
      <div className={cssStyles.logoutPicContainer} onClick={() => navigate('/login')}>
        <div className={cssStyles.profilePicWrapper}>
          <LogoutIcon style={{ width: '80%', height: '80%', color: 'white' }} />
        </div>
      </div>

      {/* <div className={cssStyles.leftSidebarIconsWrapper} onClick={() => navigate('/signout')}>
        <LogoutIcon fontSize="medium" style={{ width: '100%', height: '100%', color: "white" }} />
      </div> */}

      <Drawer
        open={showLeftDrawer}
        onClose={() => setShowLeftDrawer(false)}
        PaperProps={{
          sx: {
            backgroundColor: "rgb(51, 51, 51)"
          }
        }}
      >
        <div
          className={cssStyles.drawerContainer}
          onMouseLeave={() => {
            console.log('mouse leave');
            setShowLeftDrawer(false);
          }}
        >
          <div
            className={cssStyles.LogoIcon}
            style={{ height: '90px' }}
          >
            <img
              src={DoriLogoFull}
              alt='dorilogo'
              className={cssStyles.LeftSidebarIcons}
              height='50%'
            />
          </div>
          {/* <div className={cssStyles.drawerMenuWrapper} onClick={() => setShowLeftDrawer(false)}>
            <img
              src={CrossIcon}
              alt='cancel'
              className={cssStyles.drawerMenuIcons}
            />
            <span className='textStyle1'></span>
          </div> */}

          {
            dashRoutesUserManuAdmin.map((option, index) => {
              return (
                <div
                  key={index}
                  // className={selectedLeftOption === option.name
                  //   ? `${cssStyles.leftSidebarIconsWrapper} ${cssStyles.leftSidebarIconsWrapperSelected}`
                  //   : cssStyles.leftSidebarIconsWrapper}
                  onClick={() => {
                    setSelectedLeftOption(option.name);
                    navigate(option.layout + option.path);
                  }}
                  style={{
                    color: isSelected(option.layout + option.path)
                      ? '#17b696'
                      : 'rgb(214, 214, 214)',
                    backgroundColor:
                      isSelected(option.layout + option.path)
                        ? 'white' : ''
                  }}
                  className={cssStyles.expandedIconWrpapper}
                >
                  <div
                    className={cssStyles.sidebarIconContainerExpanded}
                    style={{
                      width: '45px'
                    }}
                  >
                    {
                      isSelected(option.layout + option.path)
                        ? option.icon('#17b696')
                        : option.icon('rgb(214, 214, 214)')
                    }
                  </div>
                  {option.name}
                </div>
              );
            })
          }

          <div className={cssStyles.nameAndPicContainer}>
            <div className={cssStyles.nameAndProfilePicWrapper}>
              <div className={cssStyles.nameAndprofilePic}>
                <AccountCircleIcon
                  style={{ width: '80%', height: '80%', color: "white" }}
                />
              </div>
              <div className='textStyle1' style={{ color: 'white', marginLeft: '5px' }}>
                {
                  store.get('user')
                    ? `${store.get('user').firstName} ${store.get('user').lastName}`
                    : 'No user'
                }
              </div>
            </div>
            <div style={{
              padding: '10px',
              marginLeft: '10px',
              borderRadius: '4px',
              backgroundColor: 'white'
            }}>
              <div className={cssStyles.accountInfo}>
                Email: <span style={{ color: '#17b696' }}>{store.get("user") &&
                  store.get("user").email
                  ? store.get("user").email
                  : ""}</span>
              </div>
              <div className={cssStyles.accountInfo}>
                Last Login Attempt: <span style={{ color: '#17b696' }}>
                  {store.get("user") &&
                    store.get("user").lastLoginTime
                    ? handleDateFormat(store.get("user")
                      .lastLoginTime)
                    : ""}</span>
              </div>
              <div className={cssStyles.accountInfo}>
                Last Login IP Address: <span style={{ color: '#17b696' }}>
                  {store.get("user") &&
                    store.get("user")
                      .lastLoginIPAddress
                    ? store.get("user")
                      .lastLoginIPAddress
                    : ""}</span>
              </div>
              <div className={cssStyles.accountInfo}>
                Version:{" "}
                <span style={{ color: '#17b696' }}>
                  {process.env.REACT_APP_BUILD_VERSION}
                </span>
              </div>
            </div>
          </div>
          <div className={cssStyles.drawerMenuWrapper} onClick={() => navigate('/login')}>
            <div className={cssStyles.nameAndprofilePic}>
              <LogoutIcon style={{ width: '80%', height: '80%', color: "white" }} />
            </div>
            <span className='textStyle1' style={{ color: 'white', marginLeft: '5px' }}>
              Logout
            </span>
          </div>
        </div>

      </Drawer>
    </div>
  )
}

export default SidebarLeft;